import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import EnrollmentConfig from '../enrollment-config/enrollment-config';
import { SectionContainer } from './styles';
import type { EnrolmentConfigForm } from './types';

interface EnrollmentConfigElementProps {
  form: EnrolmentConfigForm;
}

const EnrollmentConfigElement = ({ form }: EnrollmentConfigElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <EnrollmentConfig />
    </FormProvider>
  </SectionContainer>
);

export default memo(EnrollmentConfigElement);
